import ReactDOM from 'react-dom';
import { useState } from 'react';
import MobileMenu from '../components/MobileMenu';

const Hamburger = ({pages, handleRoute}) => {

    const [clicked, toggleClicked] = useState(false);

    return (
        <div onClick={()=>toggleClicked(!clicked)} className="w-[55px] h-[55px] text-text hover:cursor-pointer hover:text-secondary p-2 lg:hidden">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
            </svg>
            {
                clicked && ReactDOM.createPortal(<MobileMenu pages={pages} toggleClicked={toggleClicked} handleRoute={handleRoute}/>, document.body)
            }
        </div>
    )
}

export default Hamburger